<template>
  <Slider
    :value="value"
    :ticks-labels="ticksLabels"
  />
</template>

<script>
import Slider from '@/components/atoms/Slider'

export default {
  name: 'CompanyScaleSlider',
  components: {
    Slider,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ticksLabels () {
      return ['大企業', '', '', '', 'ベンチャー']
    }
  },
}
</script>
